import { render, staticRenderFns } from "./BlogDetalle.vue?vue&type=template&id=1f9146e0&scoped=true"
import script from "./BlogDetalle.vue?vue&type=script&lang=js"
export * from "./BlogDetalle.vue?vue&type=script&lang=js"
import style0 from "./BlogDetalle.vue?vue&type=style&index=0&id=1f9146e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9146e0",
  null
  
)

export default component.exports